import Link from 'next/link';
import styles from './styles.module.scss';

const Selector = props => {

    const {data, setSelectedCategory, selectedCategory} = props || {};
    const handleClick = title => {
        setSelectedCategory(title)
    }
    const renderButtons = () => {
        return data && data?.map((item, index)=> {
            const title = item?.productCategoryTitle;
            return(
                <Link onClick={(e) => {e.preventDefault(); handleClick(title)}} key={index} href="#" className={`${styles.selector__tab} button small ${selectedCategory === title ? `primary-fill` : `secondary-fill`}`}>
                    {title}
                </Link>
            );
        });
    }
    return(
        <nav className={styles.selector}>
            {renderButtons()}
        </nav>
    );
}

export default Selector;
